package org.example.project.screens_sys

import kotlinx.serialization.decodeFromString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

object UnternehmenstammApi {
    private const val EMPTY_FIELD = "~"

    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadUnternehmen(firmenId: String = ""): All? =
        decodeAll(LumaticaApiManager.call("unternehmenstamm/unternehmen/${apiPart(firmenId)}"))

    suspend fun saveUnternehmen(state: All, firmenId: String = ""): All? =
        decodeAll(
            LumaticaApiManager.call(
                listOf(
                    "unternehmenstamm",
                    "unternehmen-save",
                    firmenId,
                    state.firma,
                    state.geschaeftsfuehrer,
                    state.webseite,
                    state.gegruendetAm,
                    state.strasse,
                    state.hausnummer,
                    state.plz,
                    state.ort,
                    state.email,
                    state.telefon,
                    state.mobil,
                    state.onboarding,
                    state.lizenzMonatlich,
                    state.crSatz,
                    state.extraMeeting,
                    state.extraSchulungRemote,
                    state.supportPreis,
                    state.cloudKosten,
                    state.archivierung,
                    state.backupkosten,
                    state.setupkosten,
                    state.steuernummer,
                    state.finanzamt,
                    state.umsatzsteuerId,
                    state.kreditinstitut,
                    state.iban
                ).joinToString("/") { apiPart(it) }
            )
        )

    private fun decodeAll(raw: String): All? =
        if (raw.isBlank() || raw == "null") null
        else runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()

    private fun apiPart(value: String): String {
        val clean = value.ifBlank { EMPTY_FIELD }
        return js("encodeURIComponent")(clean) as String
    }
}
